<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <div :class="['server-side-description']" v-html="description" />
    <example-title src="example-1.html" title="Default pager example" />
    <vc-pager
      :pages="8"
      v-model="pages1"
      @input="onInput($event)" />
    <div :class="['my-16']">
      <code>v-model: {{ pages1 }}</code>
    </div>
    <example-title src="example-2.html" title="Customized pager" />
    <vc-pager
      size="small"
      :pages="8"
      shortcut-icons-color="green"
      color="orange"
      current-page-color="orange l-900"
      v-model="pages2"
      @input="onInput($event)" />
    <div :class="['my-16']">
      <code>v-model: {{ pages2 }}</code>
    </div>
    <example-title src="example-3.html" title="Large pager, hidden 'first' and 'last' buttons" />
    <vc-pager
      size="large"
      :pages="5"
      :show-first-last="false"
      shortcut-icons-color="red"
      color="deep-purple"
      current-page-color="teal"
      v-model="pages3"
      @input="onInput($event)" />
    <div :class="['my-16']">
      <code>v-model: {{ pages3 }}</code>
    </div>
    <example-title src="example-5.html" title="Custom page button label template" />
    <vc-pager
      :pages="10"
      :button-label="buttonLabel"
      v-model="pages5"
      @input="onInput($event)" />
    <div :class="['my-16']">
      <code>v-model: {{ pages5 }}</code>
    </div>
    <example-title src="example-4.html" title="Small pager, round page-only buttons" />
    <vc-pager
      round
      size="small"
      :pages="15"
      :show-first-last="false"
      :show-prev-next="false"
      v-model="pages4"
      @input="onInput($event)" />
    <div :class="['my-16']">
      <code>v-model: {{ pages4 }}</code>
    </div>
    <api-grid ref="api-grid" />
  </div>
</template>
<script>
import methods from '../helpers/methods'
export default {
  name: 'PagerPage',
  mixins: [
    methods
  ],
  data () {
    return {
      title: null,
      description: null,
      pages1: 1,
      pages2: 3,
      pages3: 4,
      pages4: 10,
      pages5: 3,
      results: 96,
      buttonLabel: (data) => {
        return `${Math.round(this.results / data.pages * data.index + 1)}-${Math.round(this.results / data.pages * (data.index + 1))}`
      }
    }
  },
  mounted () {
    this.getPage()
  },
  methods: {
    onInput (event) {
      console.log('vc-pager:input', event)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/pager.vue